import styled from 'styled-components';

export const TestIconContainer = styled.div`
    width: 100%;
    display: flex;
    height: 100%;
    max-height: 200px;

    & > svg {
        width: 100%;
    }
`;
